// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   Candidates & Hire tabs — Paper Dashboard look & feel.
   Section layout (iv-page / iv-section) comes from ../Interview/interview.css.
   Everything here is scoped with the "cand-" prefix (plus the tiny toast).
   Candidate status: Pending amber · Approved green · Rejected red · Hired blue.
   ========================================================================== */

/* ---------- Candidate list ---------- */
.cand-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.cand-item {
    background: #fff;
    border: 1px solid #e3e3e3;
    border-left: 4px solid transparent;
    border-radius: 8px;
    transition: box-shadow .15s ease, border-color .15s ease;
}

.cand-item:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
}

.cand-item.is-selected {
    border-color: #51cbce;
    border-left-color: #51cbce;
    box-shadow: 0 2px 10px rgba(81, 203, 206, .15);
}

.cand-row {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    background: transparent;
    border: none;
    text-align: left;
    cursor: pointer;
    color: #252422;
}

.cand-avatar {
    flex: 0 0 36px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    background: rgba(81, 203, 206, .15);
    color: #3aa9ac;
    text-transform: uppercase;
}

.cand-item.is-selected .cand-avatar {
    background: #51cbce;
    color: #fff;
}

.cand-main {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.cand-name {
    font-weight: 600;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cand-sub {
    font-size: 12.5px;
    color: #9a9a9a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.cand-chevron {
    color: #9a9a9a;
    font-size: 12px;
    transition: transform .2s ease;
}

.cand-item.is-selected .cand-chevron {
    transform: rotate(180deg);
    color: #51cbce;
}

.cand-details {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 28px;
    padding: 2px 14px 12px 62px;
    font-size: 13px;
    color: #66615b;
}

.cand-details b {
    color: #252422;
    font-weight: 600;
    margin-right: 4px;
}

.cand-details .btn {
    margin: 0 0 0 6px;
    padding: 2px 10px;
    font-size: 12px;
}

/* ---------- Pills ---------- */
.cand-status,
.cand-score {
    flex: 0 0 auto;
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 999px;
    white-space: nowrap;
    background: #f1f1f1;
    color: #66615b;
    text-transform: capitalize;
}

.cand-status--pending { background: #fff4d6; color: #8a6100; }
.cand-status--approved,
.cand-status--accepted { background: #dcf5e7; color: #1e7e4a; }
.cand-status--rejected { background: #fde3da; color: #b3461f; }
.cand-status--hired { background: #dff3f9; color: #1b6f87; }

/* score pill colours by value */
.cand-score--none { background: #f1f1f1; color: #9a9a9a; }
.cand-score--low { background: #fde3da; color: #b3461f; }
.cand-score--mid { background: #ffe9d1; color: #9a5210; }
.cand-score--good { background: #fff4d6; color: #8a6100; }
.cand-score--high { background: #dcf5e7; color: #1e7e4a; }

/* ---------- Evaluation panels ---------- */
.cand-panel-title {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .03em;
    color: #9a9a9a;
    margin-bottom: 8px;
}

.cand-steps .iv-step-header {
    padding: 10px 12px;
}

.cand-step-meta {
    font-size: 12px;
    color: #9a9a9a;
}

.cand-questions {
    padding: 2px 12px 12px 52px;
}

.cand-question {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 10px;
    margin-top: 6px;
    background: #fff;
    border: 1px solid #ececec;
    border-left: 3px solid transparent;
    border-radius: 6px;
    text-align: left;
    cursor: pointer;
    font-size: 13px;
    color: #252422;
}

.cand-question:hover {
    background: #f7fdfd;
    border-color: #cfeff0;
}

.cand-question.is-selected {
    background: rgba(81, 203, 206, .12);
    border-color: #51cbce;
    border-left-color: #51cbce;
    font-weight: 600;
}

.cand-question-text {
    flex: 1 1;
    min-width: 0;
    overflow-wrap: anywhere;
}

.cand-question-meta {
    font-size: 11.5px;
    color: #9a9a9a;
    white-space: nowrap;
}

/* ---------- Skill scoring ---------- */
.cand-skills-context {
    font-size: 13px;
    color: #66615b;
    background: #f7f7f7;
    border-radius: 6px;
    padding: 8px 12px;
    margin-bottom: 10px;
    overflow-wrap: anywhere;
}

.cand-skill {
    background: #fff;
    border: 1px solid #e3e3e3;
    border-radius: 8px;
    padding: 12px 14px;
    margin-bottom: 10px;
}

.cand-skill-name {
    font-weight: 600;
    font-size: 14px;
    color: #252422;
    margin-bottom: 8px;
    overflow-wrap: anywhere;
}

.cand-skill-scoreline {
    display: flex;
    align-items: center;
    gap: 12px;
}

.cand-skill-scoreline .form-control {
    width: 96px;
    flex: 0 0 96px;
    border-radius: 6px !important;
}

.cand-scorebar {
    flex: 1 1;
    height: 8px;
    border-radius: 999px;
    background: #f0f0f0;
    overflow: hidden;
}

.cand-scorebar > span {
    display: block;
    height: 100%;
    border-radius: 999px;
    transition: width .2s ease;
}

.cand-skill-comment {
    margin-top: 10px;
}

.cand-skill-comment .form-control {
    border-radius: 6px !important;
    max-height: none !important;
    font-size: 13px;
}

.cand-skill-comment-text {
    margin-top: 8px;
    font-size: 13px;
    color: #66615b;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.cand-lock {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    border-radius: 8px;
    background: #fff4d6;
    color: #8a6100;
    font-size: 13px;
    margin-top: 6px;
}

.cand-readonly-text {
    min-height: 60px;
    padding: 10px 12px;
    border: 1px solid #ececec;
    border-radius: 6px;
    background: #fafafa;
    font-size: 14px;
    color: #252422;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
}

.cand-readonly-text.is-empty {
    color: #9a9a9a;
}

/* ---------- Tiny toast (kept from the previous version) ---------- */
.tiny-toast {
    position: fixed;
    right: 16px;
    bottom: 16px;
    color: #fff;
    padding: 8px 12px;
    border-radius: 8px;
    box-shadow: 0 6px 16px rgba(0, 0, 0, .2);
    z-index: 9999;
    font-weight: 600;
    font-size: 12px;
}

.tiny-toast--info { background: #51bcda; }
.tiny-toast--success { background: #6bd098; }
.tiny-toast--warning { background: #fbc658; color: #5c4400; }
.tiny-toast--error { background: #ef8157; }

@media (max-width: 576px) {
    .cand-details,
    .cand-questions {
        padding-left: 14px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/industry/advertisements/Candidates/Candidates.css"],"names":[],"mappings":"AAAA;;;;;+EAK+E;;AAE/E,yCAAyC;AACzC;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,wDAAwD;AAC5D;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,qBAAqB;IACrB,0BAA0B;IAC1B,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mCAAmC;IACnC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,2BAA2B;IAC3B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,gCAAgC;AAChC;;IAEI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,0BAA0B;AAC9B;;AAEA,wBAAwB,mBAAmB,EAAE,cAAc,EAAE;AAC7D;yBACyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,yBAAyB,mBAAmB,EAAE,cAAc,EAAE;AAC9D,sBAAsB,mBAAmB,EAAE,cAAc,EAAE;;AAE3D,gCAAgC;AAChC,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,mBAAmB,mBAAmB,EAAE,cAAc,EAAE;AACxD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD,4CAA4C;AAC5C;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA,sEAAsE;AACtE;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA,oBAAoB,mBAAmB,EAAE;AACzC,uBAAuB,mBAAmB,EAAE;AAC5C,uBAAuB,mBAAmB,EAAE,cAAc,EAAE;AAC5D,qBAAqB,mBAAmB,EAAE;;AAE1C;IACI;;QAEI,kBAAkB;IACtB;AACJ","sourcesContent":["/* ==========================================================================\n   Candidates & Hire tabs — Paper Dashboard look & feel.\n   Section layout (iv-page / iv-section) comes from ../Interview/interview.css.\n   Everything here is scoped with the \"cand-\" prefix (plus the tiny toast).\n   Candidate status: Pending amber · Approved green · Rejected red · Hired blue.\n   ========================================================================== */\n\n/* ---------- Candidate list ---------- */\n.cand-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.cand-item {\n    background: #fff;\n    border: 1px solid #e3e3e3;\n    border-left: 4px solid transparent;\n    border-radius: 8px;\n    transition: box-shadow .15s ease, border-color .15s ease;\n}\n\n.cand-item:hover {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, .06);\n}\n\n.cand-item.is-selected {\n    border-color: #51cbce;\n    border-left-color: #51cbce;\n    box-shadow: 0 2px 10px rgba(81, 203, 206, .15);\n}\n\n.cand-row {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    background: transparent;\n    border: none;\n    text-align: left;\n    cursor: pointer;\n    color: #252422;\n}\n\n.cand-avatar {\n    flex: 0 0 36px;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    background: rgba(81, 203, 206, .15);\n    color: #3aa9ac;\n    text-transform: uppercase;\n}\n\n.cand-item.is-selected .cand-avatar {\n    background: #51cbce;\n    color: #fff;\n}\n\n.cand-main {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.cand-name {\n    font-weight: 600;\n    font-size: 14px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.cand-sub {\n    font-size: 12.5px;\n    color: #9a9a9a;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.cand-chevron {\n    color: #9a9a9a;\n    font-size: 12px;\n    transition: transform .2s ease;\n}\n\n.cand-item.is-selected .cand-chevron {\n    transform: rotate(180deg);\n    color: #51cbce;\n}\n\n.cand-details {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px 28px;\n    padding: 2px 14px 12px 62px;\n    font-size: 13px;\n    color: #66615b;\n}\n\n.cand-details b {\n    color: #252422;\n    font-weight: 600;\n    margin-right: 4px;\n}\n\n.cand-details .btn {\n    margin: 0 0 0 6px;\n    padding: 2px 10px;\n    font-size: 12px;\n}\n\n/* ---------- Pills ---------- */\n.cand-status,\n.cand-score {\n    flex: 0 0 auto;\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 3px 10px;\n    border-radius: 999px;\n    white-space: nowrap;\n    background: #f1f1f1;\n    color: #66615b;\n    text-transform: capitalize;\n}\n\n.cand-status--pending { background: #fff4d6; color: #8a6100; }\n.cand-status--approved,\n.cand-status--accepted { background: #dcf5e7; color: #1e7e4a; }\n.cand-status--rejected { background: #fde3da; color: #b3461f; }\n.cand-status--hired { background: #dff3f9; color: #1b6f87; }\n\n/* score pill colours by value */\n.cand-score--none { background: #f1f1f1; color: #9a9a9a; }\n.cand-score--low { background: #fde3da; color: #b3461f; }\n.cand-score--mid { background: #ffe9d1; color: #9a5210; }\n.cand-score--good { background: #fff4d6; color: #8a6100; }\n.cand-score--high { background: #dcf5e7; color: #1e7e4a; }\n\n/* ---------- Evaluation panels ---------- */\n.cand-panel-title {\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: .03em;\n    color: #9a9a9a;\n    margin-bottom: 8px;\n}\n\n.cand-steps .iv-step-header {\n    padding: 10px 12px;\n}\n\n.cand-step-meta {\n    font-size: 12px;\n    color: #9a9a9a;\n}\n\n.cand-questions {\n    padding: 2px 12px 12px 52px;\n}\n\n.cand-question {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 10px;\n    margin-top: 6px;\n    background: #fff;\n    border: 1px solid #ececec;\n    border-left: 3px solid transparent;\n    border-radius: 6px;\n    text-align: left;\n    cursor: pointer;\n    font-size: 13px;\n    color: #252422;\n}\n\n.cand-question:hover {\n    background: #f7fdfd;\n    border-color: #cfeff0;\n}\n\n.cand-question.is-selected {\n    background: rgba(81, 203, 206, .12);\n    border-color: #51cbce;\n    border-left-color: #51cbce;\n    font-weight: 600;\n}\n\n.cand-question-text {\n    flex: 1;\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n\n.cand-question-meta {\n    font-size: 11.5px;\n    color: #9a9a9a;\n    white-space: nowrap;\n}\n\n/* ---------- Skill scoring ---------- */\n.cand-skills-context {\n    font-size: 13px;\n    color: #66615b;\n    background: #f7f7f7;\n    border-radius: 6px;\n    padding: 8px 12px;\n    margin-bottom: 10px;\n    overflow-wrap: anywhere;\n}\n\n.cand-skill {\n    background: #fff;\n    border: 1px solid #e3e3e3;\n    border-radius: 8px;\n    padding: 12px 14px;\n    margin-bottom: 10px;\n}\n\n.cand-skill-name {\n    font-weight: 600;\n    font-size: 14px;\n    color: #252422;\n    margin-bottom: 8px;\n    overflow-wrap: anywhere;\n}\n\n.cand-skill-scoreline {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.cand-skill-scoreline .form-control {\n    width: 96px;\n    flex: 0 0 96px;\n    border-radius: 6px !important;\n}\n\n.cand-scorebar {\n    flex: 1;\n    height: 8px;\n    border-radius: 999px;\n    background: #f0f0f0;\n    overflow: hidden;\n}\n\n.cand-scorebar > span {\n    display: block;\n    height: 100%;\n    border-radius: 999px;\n    transition: width .2s ease;\n}\n\n.cand-skill-comment {\n    margin-top: 10px;\n}\n\n.cand-skill-comment .form-control {\n    border-radius: 6px !important;\n    max-height: none !important;\n    font-size: 13px;\n}\n\n.cand-skill-comment-text {\n    margin-top: 8px;\n    font-size: 13px;\n    color: #66615b;\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n}\n\n.cand-lock {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 12px;\n    border-radius: 8px;\n    background: #fff4d6;\n    color: #8a6100;\n    font-size: 13px;\n    margin-top: 6px;\n}\n\n.cand-readonly-text {\n    min-height: 60px;\n    padding: 10px 12px;\n    border: 1px solid #ececec;\n    border-radius: 6px;\n    background: #fafafa;\n    font-size: 14px;\n    color: #252422;\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n}\n\n.cand-readonly-text.is-empty {\n    color: #9a9a9a;\n}\n\n/* ---------- Tiny toast (kept from the previous version) ---------- */\n.tiny-toast {\n    position: fixed;\n    right: 16px;\n    bottom: 16px;\n    color: #fff;\n    padding: 8px 12px;\n    border-radius: 8px;\n    box-shadow: 0 6px 16px rgba(0, 0, 0, .2);\n    z-index: 9999;\n    font-weight: 600;\n    font-size: 12px;\n}\n\n.tiny-toast--info { background: #51bcda; }\n.tiny-toast--success { background: #6bd098; }\n.tiny-toast--warning { background: #fbc658; color: #5c4400; }\n.tiny-toast--error { background: #ef8157; }\n\n@media (max-width: 576px) {\n    .cand-details,\n    .cand-questions {\n        padding-left: 14px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
